<template lang="pug">
.price-reduction-renewal-container(v-if="info.couponMaps" @touchmove.prevent)
  .receive-packet-close(@click="closeModal")
    img.close(src="https://m.hellobike.com/resource/gallery/61/BSPwuX9HBi.png?x-oss-process=image/quality,q_80")
  .now-money-container
    .top-block
      .top-word
        span 获得
        span.red-font {{info.couponMaps.circle.couponPromoAmount}}元
        span 连续包月专享优惠
      .top-time
        .time-block {{h}}
        span.marign-block :
        .time-block {{m}}
        span.marign-block :
        .time-block {{s}}
        .top-time-word 后优惠失效
      .origin-price
        .origin-price-word 原价
        .origin-price-money ¥{{info.markedPrice}}
      .now-price
        .now-price-word 限时价
        .now-price-money ¥{{info.price}}
    .btn-block(@click="buy")
      .btn-block-word 连续包月首月¥
      .btn-block-num {{info.price}}
      .btn-small-num {{info.markedPrice}}
  .shadow
    </template>

<script>
import { showTime } from '../utils.js';

export default {
  components: {
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
    time: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      h: '',
      m: '',
      s: '',
      timer: null,
      timeout: null,
    };
  },
  watch: {
    time(val) {
      if (val) {
        this.openTime();
      }
    },
  },
  mounted() {
    this.openTime();
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false);
    },
    openTime() {
      // const now = new Date().getTime();
      this.timeout = 24 * 60 * 60 * 1000;
      this.timer = setInterval(() => {
        if (this.timeout === 0) {
          clearInterval(this.timer);
          return;
        }
        const time = showTime(this.timeout);
        this.h = time.H;
        this.m = time.M;
        this.s = time.S;
        this.timeout -= 1000;
      }, 1000);
    },
    buy() {
      this.$emit('buyContinue', true, 30, this.info.price, this.info.goodsGuid);
      this.closeModal();
    },
  },
  buy() {
    this.$emit('buyContinue', true, this.noPayData.orderOptType, this.noPayData.price, this.noPayData.goodsGuid);
  },
};
</script>
<style lang="less" scoped>

.price-reduction-renewal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 222;

  .receive-packet-close {
    z-index: 222;
    position: relative;
    padding-top: 2.02rem;
    margin-left: 3.04rem;

    img {
      z-index: 223;
      width: 0.32rem;
      height: 0.32rem;
    }
  }

  .now-money-container {
    margin: 0.11rem auto 0 auto;
    background-image: url('https://m.hellobike.com/resource/gallery/61/_wR81G-A_Group%201707481870.png?x-oss-process=image/quality,q_80');
    background-size: 100% 100%;
    width: 2.93rem;
    height: 3.38rem;
    position: relative;
    z-index: 223;

    .top-block {
      padding: 0.15rem 0 0 0.28rem;
      position: relative;

      .top-word {
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.18rem;
        font-weight: 500;
        color: #6f2500;

        .red-font {
          color: #fa2a00;
        }
      }

      .top-time {
        margin-top: 0.05rem;
        display: flex;
        color: #6f2500;
        line-height: 0.16rem;

        .time-block {
          width: 0.14rem;
          height: 0.16rem;
          background: #6f2500;
          color: #fff;
          text-align: center;
          font-size: 0.1rem;
          border-radius: 0.04rem;
        }

        .marign-block {
          margin: 0 0.02rem;
        }

        .top-time-word {
          margin-left: 0.04rem;
        }
      }

      .origin-price {
        position: absolute;
        top: 1rem;
        left: 0.24rem;
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.14rem;
        font-weight: 600;
        text-align: left;

        .origin-price-word {
          font-weight: 400;
        }
        .origin-price-money {
          margin-top: -0.04rem;
        }
      }

      .now-price {
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.15rem;
        font-weight: 600;
        line-height: 0.17rem;
        text-align: center;
        color: #fff;
        position: absolute;
        top: 1.52rem;
        right: 0.83rem;

        .now-price-word {
          font-size: 0.12rem;
        }
      }
    }

    .btn-block {
      display: flex;
      justify-content: center;
      margin: 2.04rem auto 0 auto;
      color: #fff;
      height: 0.46rem;
      line-height: 0.46rem;

      .btn-block-word {
        margin-top: 0.02rem;
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.14rem;
        font-weight: 600;
      }

      .btn-block-num {
        margin-left: 0.04rem;
        margin-right: 0.06rem;
        font-family: DIN, sans-serif;
        ;
        font-size: 0.24rem;
        font-weight: 700;
      }

      .btn-small-num {
        margin-top: 0.04rem;
        font-family: PingFang SC, sans-serif;
        font-size: 0.12rem;
        font-weight: 400;
        color: #fdc8b4;
        text-decoration-line: line-through;
      }
    }

    /* .receive-packet-close {
      margin-top: 0.37rem;
      display: flex;
      justify-content: center;
      z-index: 101;
      position: relative;

      .close {
        width: 0.3rem;
        height: 0.3rem;
        z-index: 101;
      }
    } */
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }
}
</style>
